module.exports = __webpack_public_path__ + "media/dorobek/assets/images/person-3d089d56476a30146fc54e995650179b.svg";